import { verifyNow } from '@theme/js/components/main/Jumio/server';
import { getRedirectUrl } from '@theme/js/components/main/Jumio/helpers';
import * as actions from './store/actions';

export const handleVerifyClick = (dispatch, onClosePopupError) => {
    verifyNow({
        successUrl: getRedirectUrl('success'),
        errorUrl: getRedirectUrl('error')
    }).then(({ data: { redirectURL } }) =>
        dispatch(actions.showJumioiFrameAction(
            { content: `<iframe allow="camera" src=${redirectURL} class="jumio-iframe"></iframe>`, onClose: onClosePopupError }
        )));
};

export const handlePostMessage = (
    onClosePopup,
    showNotification
) => ({ data }) => {
    const isJson = (str) => {
        try {
            JSON.parse(str);
        } catch (e) {
            return false;
        }
        return true;
    };
    if (typeof data !== 'string' || !isJson(data)) {
        return;
    }
    const { eventType, payload: { value: status } = {} } = JSON.parse(data) ?? {};
    if (eventType === 510 && status !== 'loaded') {
        setTimeout(() => {
            onClosePopup();
            showNotification(`playtech.mobile.system.jumio.${status}`, { variant: status });
        }, 1000);
    }
};
